const useTouchEvents = Modernizr.mobile && Modernizr.touchevents;

NLMK.useTouchEvents = useTouchEvents;

NLMK.MOUSEENTER_EVENT = useTouchEvents ? 'touchstart' : 'mouseenter';
NLMK.MOUSELEAVE_EVENT = useTouchEvents ? 'touchend' : 'mouseleave';

NLMK.MOUSEDOWN_EVENT = useTouchEvents ? 'touchstart' : 'mousedown';
NLMK.MOUSEUP_EVENT = useTouchEvents ? 'touchend' : 'mouseup';

NLMK.TOUCHSTART_EVENT = useTouchEvents ? 'touchstart' : 'mouseenter';
NLMK.TOUCHEND_EVENT = useTouchEvents ? 'touchend' : 'mouseleave';

NLMK.CLICK_START_EVENT = useTouchEvents ? 'touchstart' : 'click';
NLMK.CLICK_END_EVENT = useTouchEvents ? 'touchend' : 'click';

NLMK.events = {
    TABS_CHANGE: 'tabs.js:change',
    DISABLED_MOBILE_NAVIGATION: 'disabled-mobile-navigation'
};

// todo: onResize // .on('touchstart mousedown', (evt) => {evt.type})



// WEBPACK FOOTER //
// ./js/main/package/events.js